const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/oauth-clients/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/oauth-clients')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_organization'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings.oauthClients.title)
  })
});